
const TargetField = {
    NONE: "NONE",
    ONE: "ONE",
    MANY: "MANY"
};
export default TargetField;
